module.exports = __webpack_public_path__ + "static/media/sliderItem10.002be702.JPG";